import { render } from "./Index.vue?vue&type=template&id=4bc5bca5"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"components/Home/Features/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4bc5bca5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4bc5bca5', __exports__)) {
    api.reload('4bc5bca5', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=4bc5bca5", () => {
    api.rerender('4bc5bca5', render)
  })

}


export default __exports__